import React from 'react';
import qs from 'qs';
import { toast } from 'react-toastify';
import FileDownload from 'react-file-download';
import irelandApi from '../irelandApi';
import { actions } from 'react-redux-form';
import store from '../store';
import ToastMessage from '../components/common/toast-message';
import { toInt } from '../utils/commonFunctions';
import { airbrakeNotifier } from '../utils/commonFunctions';
import {getMinimumOrderQuantityAndNotify} from "../utils/minimum-order-quantity-toast";

export const getOrders = (orderNumber, dateFrom, dateTo, status) => (dispatch) => {
  dispatch({
    type:    "GET_ORDERS_PENDING",
    payLoad: []
  });

  let q = {
    order_number:    orderNumber,
    order_date_from: dateFrom,
    order_date_to:   dateTo,
    status:          status
  };

  return irelandApi.get(`/api/admin/orders?${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
                   .then((response) => {
                     dispatch({
                       type:    "GET_ORDERS_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_ORDERS_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getNewOrders = (query) => (dispatch) => {
  dispatch({type: "GET_NEW_ORDERS_PENDING"});

  return irelandApi.get(`/api/products?${qs.stringify({q: query}, {encodeValuesOnly: true, arrayFormat: 'brackets'})}`)
                   .then((response) => {
                     dispatch({
                       type:    "GET_NEW_ORDERS_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_NEW_ORDERS_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getMyBasket = () => (dispatch) => {
  dispatch({type: "GET_MY_BASKET_PENDING"});

  return irelandApi.get(`/api/my_basket`)
                   .then((response) => {
                     // LOAD BASKET ITEMS
                     dispatch({ type: 'LOAD_BASKET_ITEMS', payLoad: {
                       basket_data: response.data.data.attributes.basket[0],
                       basket_total: response.data.meta["basket-total"],
                       basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
                       basket_errors: response.data.meta["errors"]
                     }});
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_MY_BASKET_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getCompleteOrders = (orderNumber, page = 1) => (dispatch) => {
  const q = {
    order_number: orderNumber,
    status:       'confirmed'
  };
  dispatch({type: "GET_COMPLETE_ORDERS_PENDING"});
  return irelandApi.get(`/api/orders?${qs.stringify({q: q}, {encodeValuesOnly: true})}`, {params: {page: page}})
                   .then((response) => {
                     dispatch({
                       type:    "GET_COMPLETE_ORDERS_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_COMPLETE_ORDERS_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getSavedOrders = (page = 1) => (dispatch) => {
  const q = {status: 'saved_for_later'};
  dispatch({type: "GET_SAVED_ORDERS_PENDING"});
  return irelandApi.get(`/api/orders?${qs.stringify({q: q}, {encodeValuesOnly: true})}`, {params: {page: page}})
                   .then((response) => {
                     dispatch({
                       type:    "GET_SAVED_ORDERS_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_SAVED_ORDERS_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getValidOrderDates = () => (dispatch) => {
  dispatch({type: "GET_VALID_ORDER_DATES_PENDING"});
  return irelandApi.get(`/api/orders/valid_dates`)
    .then((response) => {
      dispatch({
        type:    "GET_VALID_ORDER_DATES_FULFILLED",
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type:    'GET_VALID_ORDER_DATES_REJECTED',
        payLoad: error.data
      })
    })
};

export const viewInvoice = (id) => (dispatch) => {
  return irelandApi.get(`/api/invoices/invoice_report/${id}`,
    {
      headers: {'Accept': 'application/pdf'},
      responseType: 'blob'
    })
                   .then((response) => {
                     let filename = "order-invoice.pdf";
                     const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                     const matches = filenameRegex.exec(response.headers['content-disposition']);
                     if (matches && matches[1]) {
                       filename = matches[1].replace(/['"]/g, '');
                     }
                     FileDownload(response.data, filename);
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message={`Invoice can not be downloaded: ${error.response.data.errors[0]}`}/>);
                   })
};

export const downloadStockSheet = () => (dispatch) => {
  return irelandApi.get(`/api/products/stock_sheet`,
    {
      headers: {'Accept': 'application/pdf'},
      responseType: 'blob'
    })
                   .then((response) => {
                     let filename = "stock-sheet.pdf";
                     const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                     const matches = filenameRegex.exec(response.headers['content-disposition']);
                     if (matches && matches[1]) {
                       filename = matches[1].replace(/['"]/g, '');
                     }
                     FileDownload(response.data, filename);
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message={`Stock sheet can not be downloaded: ${error.response.data.errors[0]}`}/>);
                   })
};

export const getOrder = (id) => (dispatch) => {
  dispatch({type: "GET_ORDER_PENDING"});
  return irelandApi.get(`/api/orders/${id}`)
                   .then((response) => {
                     dispatch({
                       type:    "GET_ORDER_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_ORDER_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getOrderNow = (id) => (dispatch) => {
  dispatch({type: "GET_ORDER_NOW_PENDING"});
  return irelandApi.get(`/api/outlets/${id}/order_now`)
                   .then((response) => {
                     dispatch({
                       type:    "GET_ORDER_NOW_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    'GET_ORDER_NOW_REJECTED',
                       payLoad: error.data
                     })
                   })
};


export const completeOrder = (id) => (dispatch) => {
  dispatch({type: "COMPLETE_ORDER_PENDING"});
  return irelandApi.post(`/api/orders/${id}/complete`)
                   .then((response) => {
                       return Promise.resolve(response);
                   })
                   .catch((error) => {
                        dispatch({type: 'COMPLETE_ORDER_REJECTED', payLoad: error.data})
                   })
};

export const orderAgain = (id) => (dispatch) => {
  dispatch({type: "COMPLETE_ORDER_PENDING"});
  return irelandApi.post(`/api/orders/${id}/order_again`)
                   .then((response) => {
                       return Promise.resolve(response);
                   })
                   .catch((error) => {
                       dispatch({
                         type:    'COMPLETE_ORDER_REJECTED',
                         payLoad: error.data
                       });
                   })
};

export const deleteSavedOrder = (id) => (dispatch) => {
  dispatch({type: "DELETE_SAVED_ORDER_PENDING"});
  return irelandApi.delete(`/api/orders/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Order has been successfully deleted"/>);
                     dispatch({
                       type:    "DELETE_SAVED_ORDER_FULFILLED",
                       payLoad: id
                     });
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="Error during delete order"/>);
                     dispatch({
                       type:    'DELETE_SAVED_ORDER_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const saveOrder = (payLoad) => (dispatch) => {
  dispatch({type: "SAVE_ORDER_PENDING"});
  return irelandApi.post(`/api/orders/save_for_later`, {order: payLoad})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Order has been successfully saved"/>);
                     dispatch({
                       type:    "SAVE_ORDER_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="Error during save order"/>);
                     dispatch({
                       type:    'SAVE_ORDER_REJECTED',
                       payLoad: error.data
                     })
                   })
};

export const getOrderToConfirm = (initialize, outlet_id = '') => (dispatch) => {
  dispatch({type: "GET_ORDER_CONFIRM_PENDING"});
  return irelandApi.get(`/api/my_basket/confirmation?outlet_id=${outlet_id}`)
                   .then((response) => {
                     const attributes = response.data.data.attributes;
                     const itemData = response.data.data.relationships['line-items'].data;
                     const lineItems = itemData.map(item => {
                       return {id: item.id, product_qty: item.attributes['product-qty']};
                     });

                     if (initialize) {
                       const data = {
                         line_items_attributes: lineItems,
                         outlet_id:             outlet_id === '' ? '' : outlet_id,
                         your_reference:        attributes['your-reference'] || ''
                       };

                       dispatch(actions.load('deep.order.confirm', data));
                     } else {
                       dispatch(actions.change('deep.order.confirm.line_items_attributes', lineItems));
                     }


                     dispatch({type: "GET_ORDER_CONFIRM_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_ORDER_CONFIRM_REJECTED', payLoad: error.data})
                   })
};

export const confirmOrder = (payLoad) => {
  return irelandApi.post(`/api/my_basket/confirm`, {order: payLoad})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Order has been successfully placed"/>);
                     store.dispatch({type: "CONFIRM_ORDER_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                      const basket = store.getState().viewConfig.profile.attributes.basket;
                      const defaultOutlet = store.getState().viewConfig.profile.attributes['default-outlet-id'];
                      const user = store.getState().viewConfig.profile.id;
                      const formattedError = error.response ? JSON.stringify(error.response.data) : error;

                      airbrakeNotifier.notify({
                        error: `Confirm order error: ${formattedError}`,
                        params: { order: payLoad, basket: basket, user: user, default_outlet: defaultOutlet }
                      });

                      toast.error(<ToastMessage iconStyle="error" message="Error during placing order, please try again"/>);
                      store.dispatch(actions.resetValidity('deep.order.confirm'));

                      const data = { line_items_attributes: [] }, { errors } = error.response.data;

                      if ('delivery_date' in errors) {
                        toast.error(
                          <ToastMessage iconStyle="error" message="The selected delivery date is a holiday."/>
                        );
                      }

                      Object.keys(errors).map(key => {
                        const lineItemId = key.split('.');

                        if (lineItemId.length > 1) {
                          data.line_items_attributes.push({id: lineItemId[1], product_qty: errors[key][0]})
                        }
                      });

                      return Promise.reject(data);
                   })
};

export const newOrder = () => (dispatch) => {
  return irelandApi.delete(`/api/my_basket/empty_basket`)
                   .then(() => {
                     // window.location.href = '/order/new';
                   })
                   .catch((error) => {
                     dispatch({type: 'CONFIRM_ORDER_REJECTED', payLoad: error.data})
                   })
};

export const confirmSavedOrder = (id, payLoad) => (dispatch) => {
  dispatch({type: "CONFIRM_ORDER_PENDING"});
  return irelandApi.post(`/api/orders/${id}/confirm`, {order: payLoad})
                   .then((response) => {
                     dispatch({type: "CONFIRM_ORDER_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'CONFIRM_ORDER_REJECTED', payLoad: error.data})
                   })
};

export const updateDeliveryAddress = (storeId) => (dispatch, getState) => {
  const id = toInt(storeId);

  if (storeId !== null && Object.keys(getState().orders.new.basket.line_items).length === 0) {
    let deliveryAddressStore = getState().stores.stores.find((store) => toInt(store.id) === id);

    if (deliveryAddressStore && deliveryAddressStore.attributes['ordering']) {
      dispatch({
        type: 'UPDATE_DELIVERY_ADDRESS',
        payload: {
          id: id,
          customerNumber: deliveryAddressStore.attributes['customer-number'],
          name: deliveryAddressStore.attributes['name']
        }
      });
    }
  }
}

export const addReplacementProduct = (originalProduct, replacementProduct) => (dispatch) => {
    dispatch({type: "ADD_REPLACEMENT_PRODUCT_PENDING"});
    const payLoad = {
        basket: {
            replacement_product: {
                original_product_id:  parseInt(originalProduct.id, 10),
                replacement_product_id: parseInt(replacementProduct.id, 10),
            }
        }
    };

    return irelandApi.put(`/api/my_basket/update`, payLoad)
        .then((response) => {
            // LOAD BASKET ITEMS
            const { quantity, error } = response.data.meta;

            createBasket(response.data.data.attributes.basket[0].line_items);
            dispatch({
                type:    'LOAD_BASKET_ITEMS',
                payLoad: {
                    basket_data:  response.data.data.attributes.basket[0],
                    basket_total: response.data.meta["basket-total"],
                    basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
                }
            });

            if (error) {
              toast.error(<ToastMessage iconStyle="error" message={error}/>);
            } else {
              let basket = response.data.data.attributes.basket[0];
              let replacements_length = basket.replacements.length;

              let replaces_name = basket.replacements[replacements_length -1].replaces.name;
              let replaces_stock_status = basket.replacements[replacements_length -1].replaces.stock_status;

              let replacements_quantity = basket.replacements[replacements_length -1].quantity;
              let replacements_name = basket.replacements[replacements_length -1].replacement.name;

              const message = `Based on your past order history of ${replaces_name}, which is now ${replaces_stock_status}, we have added ${replacements_quantity} outers of the replacement product ${replacements_name} to your basket. You can review the quantity in your basket now or on the order confirmation page`;
              toast.success(<ToastMessage iconStyle="success" message={message}/>);
            }
            dispatch({type: "ADD_REPLACEMENT_PRODUCT_FULFILLED"});
        })
}

export const emptyRepairBasket = () => dispatch => {
  dispatch({ type: "EMPTY_PRODUCT_REPAIRED" });
}


export const basketUpdate = (
  product,
  qty,
  {
    confirm = true,
    updateQuantity = false,
    deliveryAddressId = null,
    repairQuantity = false
  } = {}
) => (dispatch) => {
  qty = getMinimumOrderQuantityAndNotify(qty, product.attributes["minimum-order-quantity"]);
  dispatch({type: "UPDATE_BASKET_PENDING"});

  const payLoad = {
    basket: {
      line_item: {
        product_qty: qty,
        product_id:  parseInt(product.id, 10)
      },
      delivery_address_id: deliveryAddressId
    }
  };

  if (repairQuantity) payLoad.repair_quantity = '1';

  return irelandApi.put(`/api/my_basket/update`, payLoad)
                   .then((response) => {
                     const repairedQuantity = response.data.meta && response.data.meta['repaired-quantity'];

                     if (repairedQuantity) {
                       dispatch({
                         type: 'LINE_ITEM_PRODUCT_REPAIRED',
                         payload: { productId: product.id, originalQuantity: qty, quantityIncrease: repairedQuantity - qty }
                       });
                       return;
                     }

                     let newLineItem = createBasket(response.data.data.attributes.basket[0].line_items)[product.id];

                     // LOAD BASKET ITEMS
                     dispatch({
                       type:    'LOAD_BASKET_ITEMS',
                       payLoad: {
                         basket_data:  response.data.data.attributes.basket[0],
                         basket_total: response.data.meta["basket-total"],
                         basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
                         order_more_name: response.data.meta["order-more-name"],
                         order_more_products: response.data.meta["order-more-products"]
                       }
                     });


                     const confirmError = response.data.meta.error;
                     if (confirm) {
                       dispatch({
                         type: 'CONFIRM_PRODUCT',
                         payLoad: {
                           ...newLineItem,
                           total: response.data.meta["total"],
                           error: response.data.meta.error
                         }
                       });
                     } else if (confirmError) {
                       toast.error(<ToastMessage iconStyle="error"
                                                 message={confirmError}/>);
                     } else {
                       const message = updateQuantity ? 'Quantity has been updated' : 'Product has been added to your basket';
                       toast.success(<ToastMessage iconStyle="success"
                                                   message={message}/>);
                     }
                     dispatch({type: "UPDATE_BASKET_FULFILLED"});
                   })
                   .catch((error) => {
                     dispatch({
                       type:    "UPDATE_BASKET_REJECTED",
                       payLoad: error.data
                     });
                   })
};

export const basketUpdateLineItem = (lineItem, qty, fromConfirm = false) => (dispatch) => {
  qty = getMinimumOrderQuantityAndNotify(qty, lineItem.product.minimum_order_quantity);
  const payLoad = {
    basket: {
      line_item: {
        id:          parseInt(lineItem.id, 10),
        product_qty: qty
      }
    }
  };
  let apiUrl = `/api/my_basket/modify_line_item_total_quantity`;
  if (fromConfirm) {
    apiUrl = `/api/my_basket/modify_line_item_last_added_quantity`;
    // #550 seems that this endpoint not exists at all.
  }
  dispatch({type: "UPDATE_BASKET_PENDING"});
  return irelandApi.put(apiUrl, payLoad)
                   .then((response) => {

                     dispatch({type: "UPDATE_BASKET_FULFILLED", payLoad: !fromConfirm});
                     let newLineItem = createBasket(response.data.data.attributes.basket[0].line_items)[lineItem.product.id];

                     // LOAD BASKET ITEMS
                     dispatch({
                       type:    'LOAD_BASKET_ITEMS',
                       payLoad: {
                         basket_data:  response.data.data.attributes.basket[0],
                         basket_total: response.data.meta["basket-total"],
                         basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
                       }
                     });

                     const error = response.data.meta.error;
                     if (fromConfirm) {
                       dispatch({
                         type:    'CONFIRM_PRODUCT',
                         payLoad: {
                           ...newLineItem,
                           error: error
                         }
                       });
                     } else if (error) {
                       toast.error(<ToastMessage iconStyle="error"
                                                 message={error}/>);
                     } else {
                       toast.success(<ToastMessage iconStyle="success"
                                                   message="Quantity has been updated, please checkout to continue"/>);
                     }


                   })
                   .catch((error) => {
                     dispatch({
                       type:    "UPDATE_BASKET_REJECTED",
                       payLoad: error.data
                     });
                   })
};

export const deleteFromBasket = (lineItem) => (dispatch) => {
  dispatch({type: "UPDATE_BASKET_PENDING"});
  const payLoad = {
    basket: {
      line_item: {
        id: lineItem.id
      }
    }
  };
  return irelandApi.delete(`/api/my_basket/delete_item_from_basket`, {data: payLoad})
                   .then((response) => {

                     dispatch({type: "UPDATE_BASKET_FULFILLED"});
                     // LOAD EMPTY BASKET
                     dispatch({
                       type:    'LOAD_BASKET_ITEMS',
                       payLoad: {
                         basket_data:  response.data.data.attributes.basket[0],
                         basket_total: response.data.meta["basket-total"],
                         basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
                       }
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type:    "UPDATE_BASKET_REJECTED",
                       payLoad: error.data
                     });
                   })
};

export const basketClear = () => (dispatch, getState) => {
  dispatch({type: "UPDATE_BASKET_PENDING"});
  return irelandApi.delete(`/api/my_basket/empty_basket`)
                   .then((response) => {
                     dispatch({type: "UPDATE_BASKET_FULFILLED"});
                     // LOAD EMPTY BASKET
                     dispatch({
                       type:    'LOAD_BASKET_ITEMS',
                       payLoad: {
                         basket_data:  response.data.data.attributes.basket[0],
                         basket_total: response.data.meta["basket-total"],
                         basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
                       }
                     });
                   }).then(() => {
                      dispatch(updateDeliveryAddress(getState().viewConfig.profile.attributes['default-outlet-id']))
                   })
                   .catch((error) => {
                     dispatch({
                       type:    "UPDATE_BASKET_REJECTED",
                       payLoad: error.data
                     });
                   })
};

export const getNewFeaturedProducts = (storeId) => (dispatch) => {
    dispatch({type: "GET_NEW_FEATURED_PRODUCTS_PENDING"});

    const params = {
      id: storeId
    };

    return irelandApi.get(`/api/my_basket/new_featured_products?${qs.stringify({outlet: params}, {encodeValuesOnly: true})}`)
      .then((response) => {
        dispatch({type: "GET_NEW_FEATURED_PRODUCTS_FULFILLED", payLoad: response.data['data']});
      })
      .catch((error) => {
        dispatch({type: "GET_NEW_FEATURED_PRODUCTS_REJECTED", payLoad: error});
      });
}

const createBasket = (lineItems) => {
  let itemsObject = {};
  lineItems.forEach((curr) => {
    itemsObject[curr.product.id] = curr;
  });
  return itemsObject;
};



// WEBPACK FOOTER //
// ./src/actions/orders.js